import type { NAuth } from '@app/types';

export enum AuthenticationEndpoints {
  PrepareAuthenticate = 'PrepareAuthenticate',
  AuthenticateByCookie = 'AuthenticateByCookie',
  AuthenticateByEmail = 'AuthenticateByEmail',
  AuthenticateByEmailAccessCode = 'AuthenticateByEmailAccessCode',
  DecryptEmailCookie = 'DecryptEmailCookie',
  AuthenticateByPassword = 'AuthenticateByPassword',
  AuthenticateBySecret = 'AuthenticateBySecret',
  SwitchOrganization = 'SwitchOrganization',
}

export interface ModelCookie {
  Content: string | null;
}

export interface ModelAuthByEmail {
  Email: string | null;
}

export interface ModelAuthByPassword {
  Email: string | null;
  Phone: string | null;
  Password: string | null;
}

export interface AuthenticateBySecretRequest {
  secret: string;
}

// Параметров у метода нет (контракт бэка с 07.09.2026, us/11114).
export type PrepareAuthenticateRequest = void;
export type AuthenticateByCookieRequest = ModelCookie;
export type AuthenticateByEmailRequest = ModelAuthByEmail;
export type AuthenticateByEmailAccessCodeRequest = {
  email: string;
  accessCode: string;
};
export type DecryptEmailCookieRequest = ModelCookie;
export type AuthenticateByPasswordRequest = ModelAuthByPassword;
export interface SwitchOrganizationRequest {
  organizationId: number;
}

export type PrepareAuthenticateResponse = number;
export type AuthenticateByCookieResponse = NAuth.ModelAuthentication;
export type AuthenticateByEmailResponse = void;
export type AuthenticateByEmailAccessCodeResponse = NAuth.ModelAuthentication;
export type DecryptEmailCookieResponse = string;
export type AuthenticateByPasswordResponse = NAuth.ModelAuthentication;
export type AuthenticateBySecretResponse = NAuth.ModelAuthentication;
export type SwitchOrganizationResponse = NAuth.ModelAuthentication;
